import * as React from 'react';
import { ThemeProvider } from '@emotion/react';
import { InputProvider } from './InputProvider';
import { defaultCanvasTheme } from './theming';
export class CanvasProvider extends React.Component {
    render() {
        const { children, theme, ...elemProps } = this.props;
        return (React.createElement(ThemeProvider, { theme: theme },
            React.createElement(InputProvider, null),
            React.createElement("div", Object.assign({ dir: (theme.canvas && theme.canvas.direction) || defaultCanvasTheme.direction }, elemProps), children)));
    }
}
CanvasProvider.defaultProps = {
    theme: {
        canvas: defaultCanvasTheme,
    },
};
